import { startRequest, finishRequest } from "@store/utils";
import {
  GetKpiComplianceReport,
  GetKpiComplianceReportSuccess,
  GetKpiComplianceReportError,
  ExportKpiComplianceReport,
  ExportKpiComplianceReportSuccess,
  ExportKpiComplianceReportError,
} from "@modules/reporting/constants/actions";
import type { KpiComplianceReportState } from "./types";

export const initialState: KpiComplianceReportState = {
  requestsInProgress: 0,
  error: null,
  list: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
      sort: {
        orders: [],
      },
    },
    totalElements: 0,
  },
};

const setLoading = (state: KpiComplianceReportState) => () => startRequest(state);

const setLoaded = (state: KpiComplianceReportState) => () => finishRequest(state);

export const onError = (state: KpiComplianceReportState) => ({ payload }: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetKpiComplianceReportSuccess = (state: KpiComplianceReportState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  list: payload,
});

export default (state: KpiComplianceReportState = initialState, action: Object): Object => {
  const handlers = {
    // KPI Compliance
    [GetKpiComplianceReport]: setLoading,
    [GetKpiComplianceReportSuccess]: onGetKpiComplianceReportSuccess,
    [GetKpiComplianceReportError]: onError,
    [ExportKpiComplianceReport]: setLoading,
    [ExportKpiComplianceReportSuccess]: setLoaded,
    [ExportKpiComplianceReportError]: onError,
  };

  if (handlers[action.type]) {
    return handlers[action.type](state)(action);
  }
  return state;
};
